import type { FunctionComponent } from "react";
import { Circle, XStack, YStack } from "tamagui";
import type { IconProps } from "@tamagui/helpers-icon";
import { Spinner } from "./Spinner";
import { Paragraph, ParagraphSmall } from "./Typography";
export type UploadButtonProps = {
  title: string;
  description: string;
  icon: FunctionComponent<IconProps>;
  isLoading: boolean;
  onPress?: () => void;
};
export const UploadButton = ({
  title,
  description,
  icon: Icon,
  isLoading,
  onPress
}: UploadButtonProps) => {
  return <XStack ai="center" gap="$4.5" onPress={onPress} cursor="pointer" data-sentry-element="XStack" data-sentry-component="UploadButton" data-sentry-source-file="UploadButton.tsx">
      <YStack data-sentry-element="YStack" data-sentry-source-file="UploadButton.tsx">
        <Circle justifyContent="center" alignItems="center" size="$4" backgroundColor="$cream6" data-sentry-element="Circle" data-sentry-source-file="UploadButton.tsx">
          {isLoading ? <Spinner animation="quick" color="$color" enterStyle={{
          opacity: 0
        }} exitStyle={{
          opacity: 0
        }} /> : <Icon color="$navy" size="$1" strokeWidth={2} />}
        </Circle>
      </YStack>
      <YStack justifyContent="space-between" f={1} height="$4" data-sentry-element="YStack" data-sentry-source-file="UploadButton.tsx">
        <Paragraph data-sentry-element="Paragraph" data-sentry-source-file="UploadButton.tsx">{title}</Paragraph>
        <ParagraphSmall theme="alt1" data-sentry-element="ParagraphSmall" data-sentry-source-file="UploadButton.tsx">{description}</ParagraphSmall>
      </YStack>
    </XStack>;
};